export default __webpack_public_path__ + "static/media/mushroom-chicken-pasta.cc5f68b7.png";